import { render, staticRenderFns } from "./products.vue?vue&type=template&id=6a86169b&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"
import style0 from "./products.vue?vue&type=style&index=0&id=6a86169b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a86169b",
  null
  
)

export default component.exports